import { SSE_ENDPOINTS } from '@constants';
// To-do: polyfill event source here?

/* Opening the stream */

export const openEventStream = (queryParams, options = { withCredentials: true }, source = EventSource) => {
  return new source(_getEventSourceUrl(queryParams), options);
};

function _getEventSourceUrl(params) {
    const { OPEN } = SSE_ENDPOINTS;
    const { leadId, connectionType, presentationType, presentationId } = params;
  
    return `${OPEN}?leadId=${leadId}&connectionType=${connectionType}&presentationType=${presentationType ?? null}&presentationId=${presentationId ?? null}`;
}
